<ng-container [formGroup]="model">
  <mat-form-field libZalamoField [noBottomMargin]="true" appearance="outline">
    <mat-label>
      <ng-content></ng-content>
    </mat-label>
    <input
      (focus)="picker2.open()"
      [matDatepicker]="picker2"
      [min]="allowPast ? null : now"
      formControlName="date"
      matInput />
    <mat-datepicker-toggle [for]="picker2" matSuffix></mat-datepicker-toggle>
    <mat-datepicker #picker2></mat-datepicker>
    <lib-zalamo-field-decoration></lib-zalamo-field-decoration
  ></mat-form-field>
  @if (!dateOnly) {
    <mat-form-field libZalamoField [noBottomMargin]="true" class="time">
      <mat-label>Godzina</mat-label>
      <input
        type="time"
        [step]="allowMinutes ? 60 : 3600"
        formControlName="time"
        matInput />
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
  }
</ng-container>
